module.exports = __webpack_public_path__ + "img/icon-garden.712703ab.svg";